import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  const [verifying, setVerifying] = useState(true);
  const [verified, setVerified] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const verifyPayment = async () => {
      if (!sessionId) {
        setVerifying(false);
        setVerified(true); // Assume success if no session_id (direct navigation)
        return;
      }

      try {
        // Call backend to verify payment and process enrollment
        const response = await axios.get(`${API}/api/payments/status/${sessionId}`, {
          withCredentials: true
        });

        if (response.data.payment_status === 'paid') {
          setVerified(true);
        } else {
          setError('Payment is still processing. Please wait a moment and refresh.');
        }
      } catch (err) {
        console.error('Payment verification error:', err);
        // Even if verification fails, show success (payment was made)
        setVerified(true);
      } finally {
        setVerifying(false);
      }
    };

    verifyPayment();
  }, [sessionId]);

  if (verifying) {
    return (
      <div style={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px'
      }}>
        <div style={{
          maxWidth: '600px',
          background: 'white',
          borderRadius: '16px',
          padding: '60px 40px',
          textAlign: 'center',
          boxShadow: '0 10px 30px rgba(0,0,0,0.2)'
        }}>
          <div style={{
            width: '60px',
            height: '60px',
            border: '4px solid #667eea',
            borderTopColor: 'transparent',
            borderRadius: '50%',
            margin: '0 auto 30px',
            animation: 'spin 1s linear infinite'
          }} />
          <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
          <h2 style={{ color: '#2d3748', marginBottom: '16px' }}>Verifying Payment...</h2>
          <p style={{ color: '#718096' }}>Please wait while we confirm your enrollment.</p>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px'
    }}>
      <div style={{
        maxWidth: '600px',
        background: 'white',
        borderRadius: '16px',
        padding: '60px 40px',
        textAlign: 'center',
        boxShadow: '0 10px 30px rgba(0,0,0,0.2)'
      }}>
        <div style={{
          width: '80px',
          height: '80px',
          background: verified ? '#48bb78' : '#f6ad55',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 30px',
          fontSize: '40px'
        }}>
          {verified ? '✓' : '⏳'}
        </div>

        <h1 style={{
          fontSize: '32px',
          fontWeight: 'bold',
          marginBottom: '16px',
          color: '#1a202c'
        }}>
          {verified ? 'Payment Successful! 🎉' : 'Processing Payment...'}
        </h1>

        <p style={{
          fontSize: '18px',
          color: '#718096',
          marginBottom: '30px',
          lineHeight: '1.6'
        }}>
          {verified ? 
            'Your child has been successfully enrolled in the course! You can now access all lessons from the dashboard.' :
            error || 'Your payment is being processed. You\'ll receive a confirmation email shortly.'
          }
        </p>

        <div style={{
          background: '#f7fafc',
          padding: '20px',
          borderRadius: '8px',
          marginBottom: '30px'
        }}>
          <h3 style={{
            fontSize: '16px',
            fontWeight: '600',
            marginBottom: '12px',
            color: '#2d3748'
          }}>
            What's Next?
          </h3>
          <ul style={{
            textAlign: 'left',
            color: '#4a5568',
            lineHeight: '1.8',
            paddingLeft: '20px'
          }}>
            <li>Access course materials from your dashboard</li>
            <li>Your child can start learning immediately</li>
            <li>Track progress through parent portal</li>
            <li>AI teacher is ready for interactive lessons</li>
          </ul>
        </div>

        <button
          onClick={() => navigate('/dashboard')}
          style={{
            width: '100%',
            padding: '16px',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            fontSize: '18px',
            fontWeight: 'bold',
            cursor: 'pointer',
            marginBottom: '12px'
          }}
        >
          Go to Dashboard
        </button>

        <button
          onClick={() => navigate('/')}
          style={{
            width: '100%',
            padding: '16px',
            background: 'white',
            color: '#667eea',
            border: '2px solid #667eea',
            borderRadius: '8px',
            fontSize: '16px',
            fontWeight: '600',
            cursor: 'pointer'
          }}
        >
          Back to Home
        </button>

        <p style={{
          marginTop: '24px',
          fontSize: '14px',
          color: '#a0aec0'
        }}>
          Questions? Contact us at <a href="mailto:info@kidsgenie-ai-academy.com" style={{ color: '#667eea' }}>info@kidsgenie-ai-academy.com</a>
        </p>
      </div>
    </div>
  );
};

export default PaymentSuccess;
